import { render, staticRenderFns } from "./AgentEdit.vue?vue&type=template&id=b1284b26&scoped=true&"
import script from "./AgentEdit.vue?vue&type=script&lang=js&"
export * from "./AgentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1284b26",
  null
  
)

export default component.exports